export const POSITION_CLASSES = {
  bottomleft: 'leaflet-bottom leaflet-left',
  bottomright: 'leaflet-bottom leaflet-right',
  topleft: 'leaflet-top leaflet-left',
  topright: 'leaflet-top leaflet-right',
  verticalcenterright: 'leaflet-verticalcenter leaflet-right',
  verticalcenterleft: 'leaflet-verticalcenter leaflet-left',
};